export default ()=> {
  const hoverGroup = document.querySelectorAll('.hover-group');

  hoverGroup.forEach((item) => {
    item.addEventListener('mouseover', (e) => {
      item.classList.add('hover-group--active');
    });
    item.addEventListener('mouseout', (e) => {
      item.classList.remove('hover-group--active');
    });
  });
}